// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2tKrL","large":"styles_large__2nxGG"};